var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8452 23.3901L25.0352 22.9551C24.1202 22.8501 23.2202 23.1651 22.5752 23.8101L19.8152 26.5701C15.5702 24.4101 12.0902 20.9451 9.93018 16.6851L12.7052 13.9101C13.3502 13.2651 13.6652 12.3651 13.5602 11.4501L13.1252 7.67014C12.9452 6.15514 11.6702 5.01514 10.1402 5.01514H7.54518C5.85018 5.01514 4.44018 6.42514 4.54518 8.12014C5.34018 20.9301 15.5852 31.1601 28.3802 31.9551C30.0752 32.0601 31.4852 30.6501 31.4852 28.9551V26.3601C31.5002 24.8451 30.3602 23.5701 28.8452 23.3901Z",
    fill: "#114038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.933038adfb1449b3057957954e698a12.svg";
export { ForwardRef as ReactComponent };